import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";

export const DarkModeContext = createContext();
export const DarkModeProvider = ({ children }) => {
  const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  useEffect(() => {
    if (darkMode === true) {
      document.documentElement.style.setProperty("--title-color", "#CCD6F6");
      document.documentElement.style.setProperty(
        "--title-color-dark",
        "#F2D398"
      );
      document.documentElement.style.setProperty("--text-color", "#8892B0");
      document.documentElement.style.setProperty(
        "--text-color-light",
        "#8892B0"
      );
      document.documentElement.style.setProperty("--body-color", "#0A192F");
      document.documentElement.style.setProperty(
        "--container-color",
        "#112240"
      );
    } else {
      document.documentElement.style.setProperty(
        "--title-color",
        "hsl(var(--hue), var(--sat), 20%)"
      );
      document.documentElement.style.setProperty(
        "--title-color-dark",
        "hsl(var(--hue), var(--sat), 0%)"
      );
      document.documentElement.style.setProperty(
        "--text-color",
        "hsl(var(--hue), var(--sat), 46%)"
      );
      document.documentElement.style.setProperty(
        "--text-color-light",
        "hsl(var(--hue), var(--sat), 70%)"
      );
      document.documentElement.style.setProperty(
        "--body-color",
        "hsl(var(--hue), var(--sat), 98%)"
      );
      document.documentElement.style.setProperty("--container-color", "#fff");
    }
  }, [darkMode]);

  return (
    <DarkModeContext.Provider value={[darkMode, setDarkMode]}>
      {children}
    </DarkModeContext.Provider>
  );
};
